export default {"src":"/_next/static/media/staysure-logo-primary-xl.43d4c9fd.svg","height":39,"width":159,"blurWidth":0,"blurHeight":0};